export default {
    green: '#29553D',
    white: "#ffffff",
    black: "#222222",
    grey: '#bdbdbd',
    blue: "#002f90",
    lightBlue: "#00bee1",
    newColor: "#838b8b",
    inprogressColor: "#63b8ff",
    solvedColor: "#66cdaa",
    infollowColor: "#da70d6",
    doneColor: "#00cd00",
    onholdColor: "#cd3700",
    rejectedColor: "#8b0000",
    yellow: "#FFFF8A",
};
  